/**
 * List of available font names (visit the url`/settings/appearance`).
 * This array is used to generate Tailwind's `safelist` inside 'tailwind.config.js' and 'appearance-form.tsx'
 * to prevent dynamic font classes (e.g., `font-noto`, `font-almarai`) from being removed during purging.
 *
 * 📝 How to Add a New Font:
 * 1. Add the font name here.
 * 2. Update the `<link>` tag in 'index.html' to include the new font from Google Fonts (or any other source).
 * 3. Add new fontFamily 'tailwind.config.js'
 */
export const fonts = [
  'almarai',  // Default: bilingual Inter (Latin) + Almarai (Arabic)
  'inter',
  'noto',
  'tajawal',
  'amiri',
  'naskh',
  'system'
] as const
